"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABLE_HEADER_BUTTON_SORT_ICON_COLOR = exports.TABLE_HEADER_BUTTON_FOCUS_BORDER_COLOR = exports.TABLE_HEADER_BUTTON_BORDER_WIDTH = exports.TABLE_HEADER_BUTTON_BORDER_COLOR = exports.TABLE_CAPTION_TEXT_ALIGN = exports.TABLE_CAPTION_SIDE = exports.TABLE_CAPTION_PADDING = exports.TABLE_CAPTION_FONT_WEIGHT = exports.TABLE_CAPTION_FONT_SIZE = exports.TABLE_CAPTION_COLOR = exports.ACTION_BUTTON_WIDTH = void 0;
var ACTION_BUTTON_WIDTH = 32;
exports.ACTION_BUTTON_WIDTH = ACTION_BUTTON_WIDTH;
var TABLE_HEADER_BUTTON_BORDER_WIDTH = 2;
exports.TABLE_HEADER_BUTTON_BORDER_WIDTH = TABLE_HEADER_BUTTON_BORDER_WIDTH;
var TABLE_HEADER_BUTTON_BORDER_COLOR = 'primary70';
exports.TABLE_HEADER_BUTTON_BORDER_COLOR = TABLE_HEADER_BUTTON_BORDER_COLOR;
var TABLE_HEADER_BUTTON_FOCUS_BORDER_COLOR = 'primary80';
exports.TABLE_HEADER_BUTTON_FOCUS_BORDER_COLOR = TABLE_HEADER_BUTTON_FOCUS_BORDER_COLOR;
var TABLE_HEADER_BUTTON_SORT_ICON_COLOR = 'primary70';
exports.TABLE_HEADER_BUTTON_SORT_ICON_COLOR = TABLE_HEADER_BUTTON_SORT_ICON_COLOR;
var TABLE_CAPTION_SIDE = 'top';
exports.TABLE_CAPTION_SIDE = TABLE_CAPTION_SIDE;
var TABLE_CAPTION_TEXT_ALIGN = 'left';
exports.TABLE_CAPTION_TEXT_ALIGN = TABLE_CAPTION_TEXT_ALIGN;
var TABLE_CAPTION_FONT_SIZE = 'T300';
exports.TABLE_CAPTION_FONT_SIZE = TABLE_CAPTION_FONT_SIZE;
var TABLE_CAPTION_PADDING = 'S200';
exports.TABLE_CAPTION_PADDING = TABLE_CAPTION_PADDING;
var TABLE_CAPTION_COLOR = 'neutral90';
exports.TABLE_CAPTION_COLOR = TABLE_CAPTION_COLOR;
var TABLE_CAPTION_FONT_WEIGHT = 'bold';
exports.TABLE_CAPTION_FONT_WEIGHT = TABLE_CAPTION_FONT_WEIGHT;